import React from 'react'
import { useTranslation } from 'react-i18next'
import TournamentItem from './TournamentItem'
import Fade from 'react-reveal/Fade'

const Tournament = () => {
	const { t } = useTranslation()
	const tournaments = [
		{
			title: t('translation:tournaments:more_tournaments:title'),
			description: t('translation:tournaments:more_tournaments:description'),
			imgUrl: 'img/moretournaments.jpg',
		},
		{
			title: t('translation:tournaments:head_to_head:title'),
			description: t('translation:tournaments:head_to_head:description'),
			imgUrl: 'img/head2head.png',
		},
	]
	return (
		<section className='py-20 px-8 container mx-auto' id='tournaments'>
			<Fade left cascade>
				<div className='mt-2 px-4'>
					<h2 className='text-main-secondary_variant text-xl md:text-5xl font-bold'>
						{t('translation:tournaments:title')}
					</h2>
					<p className='text-main-secondary text-sm md:text-xl'>
						{t('translation:tournaments:subtitle')}
					</p>
				</div>
			</Fade>
			<div className='px-4 mt-4'>
				<div className='block md:flex justify-between md:-mx-2'>
					{tournaments.map((tournament, index) => (
						// eslint-disable-next-line react/jsx-key
						<TournamentItem {...tournament} key={index} />
					))}
				</div>
			</div>
		</section>
	)
}
export default Tournament
